// .u_gallery-list-item
(function ($) {
  var $items = $('.u_gallery-list-item')
  $items.each(function (i, thisItem) {
    galleryItemInit($(thisItem))
  })

  function galleryItemInit (thisItem) {
    $(thisItem).on('click', function () {
      openGallery($(this))
    })
  }
})(window.jQuery)
